import MeetingInfoBar from './MeetingInfoBar';

export default MeetingInfoBar;